import { Input } from 'common/components/Input/Input'

import styles from './other-payment-group.module.scss'

export type OtherPaymentValues = {
  amount: string
  reference: string
}

type Props = {
  values: OtherPaymentValues
  onChange: (next: OtherPaymentValues) => void
  disabled?: boolean
}

export const OtherPaymentGroup = ({ values, onChange, disabled }: Props) => {
  return (
    <div className={styles.group}>
      <div className={styles.fieldRow}>
        <Input
          name='other_amount'
          label='Amount'
          placeholder='0.00'
          inputMode='decimal'
          value={values.amount}
          parentClassName={styles.amountField}
          disabled={disabled}
          onChange={(event) => onChange({ ...values, amount: event.target.value })}
        />
        <Input
          name='other_reference'
          label='Reference'
          placeholder='e.g. check number'
          value={values.reference}
          parentClassName={styles.referenceField}
          disabled={disabled}
          onChange={(event) => onChange({ ...values, reference: event.target.value })}
        />
      </div>
    </div>
  )
}
